'use strict';

// Teams controller
angular.module('teams').controller('TeamsController', [
	'$scope',
	'$stateParams',
	'$state',
	'$location',
	'Authentication',
	'EntryCount',
	'EntryMain',
	'Teams',
	'TeamApps',
	'TeamsInfo',
	'SubscriptionMain',
	'TranslationMemory',
	'$window',
	'Utilities',
	function(
		$scope,
		$stateParams,
		$state,
		$location,
		Authentication,
		EntryCount,
		EntryMain,
		Teams,
		TeamApps,
		TeamsInfo,
		SubscriptionMain,
		TranslationMemory,
		$window,
		Utilities
	) {
		$scope.authentication = Authentication;

		$scope.entryCountMap = {};
		$scope.mobileApps = [];
		$scope.teamsInfo = {
			teamMembers: 0,
			planInfo: {},
			user: {}
		};

		$scope.currentSubscription = {};


		/**
		 * Queries the current subscription information
		 */
		$scope.getSubscription = function(forceRefresh) {
			SubscriptionMain.getUserPlan(forceRefresh, function(err, currentSubscription) {
				if (err) {
					$scope.currentSubscription = {};
					return;
				}
				$scope.currentSubscription = currentSubscription;
			});
		};


		/**
		 * Redirects use to the subscription page
		 */
		$scope.goToSubscriptionPage = function() {
			if ($scope.currentSubscription.billingId) {
				// Redirect to subscription page
				$state.go('editSubscription', {billingId: $scope.currentSubscription.billingId});
			} else {
				// Redirect to billing form
				$state.go('listBillings');
			}
		};


		/**
		 * Depending on who presses the button it does display a message to
		 * contact the owner or it gives the option to directly upgrade
         */
		$scope.updateSubscription = function(team, $event) {
			if ($event) {
				$event.stopPropagation();
			}
			if (team) {
				Utilities.upgradeSubscriptionTeam('teamMembers', team.user, $scope.authentication.user, $stateParams.teamId,
					function(err, gotUpgraded) {
						if (gotUpgraded === true) {
							// Reload with new subscription. We reload the whole
							// page because two different controllers have
							// to get updated and like that its the easiest. Also
							// does it make sure that the cache with the subscriptions
							// get reloaded so that we start with a clean slate.
							$window.location.reload();
						}
					}
				);
			} else {
				Utilities.upgradeSubscriptionModal('teamMembers', $stateParams.teamId,
					function(err, gotUpgraded) {
						if (gotUpgraded === true) {
							// Reload with new subscription. We reload the whole
							// page because two different controllers have
							// to get updated and like that its the easiest. Also
							// does it make sure that the cache with the subscriptions
							// get reloaded so that we start with a clean slate.
							$window.location.reload();
						}
					}
				);
			}

		};


		/**
		 * Creates Translation Memory for current team
		 */
		$scope.createTranslationMemory = function() {
			TranslationMemory.create({
				teamId: $stateParams.teamId
			}, function(translationMemory) {
				EntryMain.loadMobileAppsTeam($stateParams.teamId, true, function() {});
				$scope.team.translationMemory = translationMemory;
				$scope.entryCountMap[$scope.team.translationMemory._id] = EntryCount.getCountForApps({mobileAppId:$scope.team.translationMemory._id});
			}, function(error) {

				Utilities.showMessage(
					'Problem!',
					'There was a problem creating the Translation Memory!\nPlease try again later or inform support.\n\nThanks!',
					'error'
				);

			});
		};


		// Create new Team
		$scope.create = function() {
			// Create new Team object
			var team = new Teams ({
				name: this.name
			});

			// Redirect after save
			team.$save(function(response) {
				$location.path('teams/' + response._id);

				// Clear form fields
				$scope.name = '';
			}, function(errorResponse) {
				$scope.error = errorResponse.data.message;
			});
		};

		// Remove existing Team
		$scope.remove = function(team) {
			if ( team ) {
				team.$remove(function(errorResponse) {
                    $scope.error = errorResponse.data.message;
                });

				for (var i in $scope.teams) {
					if ($scope.teams [i] === team) {
						$scope.teams.splice(i, 1);
					}
				}
			} else {
				$scope.team.$remove(function() {
					$location.path('teams');
				}, function(errorResponse) {
                    $scope.error = errorResponse.data.message;
                });
			}
		};

		// Update existing Team
		$scope.update = function() {
			var team = $scope.team;

			team.$update(function() {
				$location.path('teams/' + team._id);
			}, function(errorResponse) {
				$scope.error = errorResponse.data.message;
			});
		};

		// Find a list of Teams
		$scope.find = function() {
            $scope.roleDisplayNames = {
                'owner': ' OWNER ',
                'admin': ' ADMINISTRATOR ',
                'manager': ' MANAGER ',
				'translator': ' TRANSLATOR / REVIEWER ',
				'tptadmin': ' TPT ADMIN ',
				'tptservices': ' TPT MANAGER ',
				'tpttranslator': ' TPT TRANSLATOR / REVIEWER '
            };
			$scope.teams = Teams.query();

			$scope.getSubscription();

			TeamsInfo.get({}, function(teamsInfo) {
				$scope.teamsInfo = teamsInfo;
			});
		};

		// Find existing Team
		$scope.findOne = function() {

			// Get all the apps the team has
			TeamApps.get({
				teamId: $stateParams.teamId
			}, function (mobileApps) {
				$scope.mobileApps = mobileApps || [];
				// Get the number of entries each app has
				$scope.mobileApps.forEach(function(app) {
					$scope.entryCountMap[app._id] = EntryCount.getCountForApps({mobileAppId:app._id});
				});
			});

			$scope.getSubscription();

			Teams.get({
				teamId: $stateParams.teamId
			}, function(team) {
				$scope.team = team;
				// Load additionally the counts of the translation memory
				if ($scope.team.translationMemory) {
					$scope.entryCountMap[$scope.team.translationMemory._id] = EntryCount.getCountForApps({mobileAppId:$scope.team.translationMemory._id});
				}
			});
		};

		// Getting team members count excluding being a TPT role user
		$scope.getTeamMembersCount = function(){
			if(!$scope.team){
				return 0;
			}

			var members = $scope.team.members.filter(function(m){ return m.role && !m.role.toLowerCase().includes('tpt'); });

			if(members){
				return members.length;
			} else {
				return 0;
			}
		};

		// Getting team members count excluding being a TPT role user
		$scope.getTeamsMembersCount = function(){
			if(!$scope.teamsInfo.teamMembers){
				return 0;
			}

			var members = $scope.teamsInfo.teamMembers.filter(function(m){ return m.role && !m.role.toLowerCase().includes('tpt'); });

			if(members){
				return members.length;
			} else {
				return 0;
			}
		};
	}
]);
